// extracted by mini-css-extract-plugin
module.exports = {"headline":"H2_headline__p0Van"};